module.exports = __webpack_public_path__ + "img/software.d3717550.png";